import { ActionBase } from '../../../core/store/action/ActionBase';
import { DateFramedMessageModel } from '../../models/DateFramedMessageModel';

export const GET_MESSAGES_ACTION = '[Configuration] Messages Get Messages Action';

export class GetMessagesAction implements ActionBase {
  readonly identifier = new Date().getTime().toString();
  readonly type = GET_MESSAGES_ACTION;

  constructor() {}
}



// WEBPACK FOOTER //
// ./src/app/messages/store/actions/GetMessagesAction.ts